// extracted by mini-css-extract-plugin
export default {"input":"css-idkwHAmopT","input_labelText":"css-sfZk36yvDt","label__error":"css-23C8Fw4iob"};